/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { Response } from '@neo4j-ndl/react/ai';
import { useEffect, useState } from 'react';

const StreamingComponent = () => {
  const [content, setContent] = useState('');

  useEffect(() => {
    const fullContent = `
# Streaming Response

This content is being **streamed (and here's a long long long long bold text)** to simulate an AI response.

It handles:
1. Partial updates
2. Incomplete markdown
3. Code blocks

\`\`\`javascript
function stream() {
  return "streaming...";
}
\`\`\`
And here comes more text after the code block.`;

    let currentIndex = 0;
    const interval = setInterval(() => {
      if (currentIndex < fullContent.length) {
        setContent(fullContent.slice(0, currentIndex + 1));
        currentIndex++;
      } else {
        clearInterval(interval);
      }
    }, 30);

    return () => clearInterval(interval);
  }, []);

  return <Response>{content}</Response>;
};

export const Component = () => {
  return <StreamingComponent />;
};

export default Component;
